export enum ChartType{
    UNKNOWN, 
    CONTACTS, 
    ORDERS,
    REVENUE,
    ATTENDANCE
}